import React, { useEffect, useState } from 'react';
import { listMeetings } from '../../services/explorerService';
import MeetingHistoryCard from './MeetingHistoryCard';
import './meetingHistoryLanding.css';

export default function RecentMeetingsSection({
  companyId,
  recruiterId,
  onViewAll,
  onOpenMeeting,
}) {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!companyId || !recruiterId) {
      setItems([]);
      return undefined;
    }
    let alive = true;
    setLoading(true);
    listMeetings({
      companyId,
      recruiterId,
      status: 'ended',
      limit: 6,
      skip: 0,
    })
      .then((res) => {
        if (alive) setItems(res.items || []);
      })
      .catch(() => {
        if (alive) setItems([]);
      })
      .finally(() => {
        if (alive) setLoading(false);
      });
    return () => {
      alive = false;
    };
  }, [companyId, recruiterId]);

  if (!companyId || !recruiterId) return null;
  if (!loading && items.length === 0) return null;

  const showViewAll = typeof onViewAll === 'function';

  return (
    <section className="mg-recent">
      <div className="mg-recent__head">
        <h2>Recent Meetings</h2>
        {showViewAll && (
          <button type="button" className="mg-recent__all" onClick={onViewAll}>
            View all →
          </button>
        )}
      </div>
      {loading ? (
        <div className="mg-recent__loading" role="status" aria-live="polite">
          <span className="mg-hist-spinner mg-hist-spinner--lg" aria-hidden />
          <p>Loading recent meetings…</p>
        </div>
      ) : (
        <div className="mg-hist-grid mg-hist-grid--compact">
          {items.map((item) => (
            <MeetingHistoryCard
              key={item.roomName}
              item={item}
              variant="recent"
              layout="grid"
              onOpen={onOpenMeeting}
            />
          ))}
        </div>
      )}
    </section>
  );
}
